var _style, _rect, _polyline, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonoEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#3B3B3B;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.96,
    y: 4.77,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 48.7779 -24.9639)",
    className: "st0",
    width: 27.13,
    height: 83.26
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "15.49,66.24 9.86,91.06 34.68,85.43 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 60.73,
    y1: 20.96,
    x2: 79.88,
    y2: 40.12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.12,
    y1: 75.62,
    x2: 70.15,
    y2: 30.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonoEditPencil);
export default __webpack_public_path__ + "static/media/mono-edit-pencil.d1c606a1b5ac2c25e42401503263b4d0.svg";
export { ForwardRef as ReactComponent };